export default "__VITE_ASSET__DHKYJzsF__"